import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=6a7f3e03"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports